export default __webpack_public_path__ + "static/media/sports10.24ad5d4e.jpg";